import React, { useState, useEffect } from "react";
import SummaryApi from "../common";
import { toast } from "react-hot-toast";
import { Upload, Ruler, Weight, Box, Plus, Edit, X, Search, Image as ImageIcon  } from "lucide-react";
const IMAGE_BASE_URL = SummaryApi?.productImage?.url 
  ? SummaryApi.productImage.url.replace("/api/uploads", "") 
  : "http://localhost:3001";
const ProductDimentions = () => {
  const [dimensionsList, setDimensionsList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
const [previewImage, setPreviewImage] = useState("");
  const [formData, setFormData] = useState({
    dimensions_id: "", // For edit mode
    product_id: "",
    product_unit_id: "",
    weight: "",
    height: "",
    length: "",
    breadth: "",
    box_image: null,
    is_active: 1,
  });

  // 1. Initial Data Fetch
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [dimRes, prodRes] = await Promise.all([
        fetch(SummaryApi.getAllDimensions.url, { method: "GET" }),
        fetch(SummaryApi.getActiveProduct.url, { method: "GET" })
      ]);
      
      const dimData = await dimRes.json();
      const prodData = await prodRes.json();

      if (dimData.status || dimData.success) setDimensionsList(dimData.data || []);
      if (prodData.status || prodData.success) setProductList(prodData.data || []);
    } catch (err) {
      toast.error("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  // 2. Modal Handlers
  const handleOpenAdd = () => {
    setIsEditMode(false);
    setFormData({
      dimensions_id: "",
      product_id: "",
      product_unit_id: "",
      weight: "",
      height: "",
      length: "",
      breadth: "",
      box_image: null,
      is_active: 1,
    });
    setUnitList([]);
    setShowModal(true);
  };

  const handleOpenEdit = (item) => {
    setIsEditMode(true);
    // Find units for the selected product to populate the dropdown
    const selectedProduct = productList.find(p => p.product_id === item.product_id);
    setUnitList(selectedProduct?.units || []);
    
    setFormData({
      ...item,
      existing_image: item.box_image, // Store path from DB
      box_image: null, 
    });
    setShowModal(true);
  };

  // 3. Form Logic (Your existing logic)
  const handleProductChange = (e) => {
    const selectedId = e.target.value;
    const selectedProduct = productList.find(p => p.product_id.toString() === selectedId);
    setFormData(prev => ({ ...prev, product_id: selectedId, product_unit_id: "", weight: "" }));
    setUnitList(selectedProduct?.units || []);
  };

  const handleUnitChange = (e) => {
    const selectedUnitId = e.target.value;
    const selectedUnit = unitList.find(u => u.product_unit_id.toString() === selectedUnitId);
    setFormData(prev => ({
      ...prev,
      product_unit_id: selectedUnitId,
      weight: selectedUnit ? selectedUnit.weight : prev.weight 
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const apiConfig = isEditMode ? SummaryApi.updateProductDimensions : SummaryApi.createProductDimensions;

    const dataToSend = new FormData();
    Object.keys(formData).forEach(key => {
      if (formData[key] !== null) dataToSend.append(key, formData[key]);
    });

    try {
      const response = await fetch(apiConfig.url, {
        method: apiConfig.method,
        body: dataToSend,
      });
      const result = await response.json();

      if (result.success || result.status) {
        toast.success(isEditMode ? "Dimensions Updated!" : "Dimensions Created!");
        setShowModal(false);
        fetchData(); // Refresh list
      } else {
        toast.error(result.message || "Operation failed");
      }
    } catch (error) {
      toast.error("Server Error");
    } finally {
      setLoading(false);
    }
  };
 const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, box_image: file });
      setPreviewImage(URL.createObjectURL(file)); // Create local preview
    }
  };
  // Filter List Logic
  const filteredList = dimensionsList.filter(item => {
    const prod = productList.find(p => p.product_id === item.product_id);
    return prod?.product_title.toLowerCase().includes(searchTerm.toLowerCase());
  });

  return (
    <div className="min-h-screen bg-pink-50/30 p-4 md:p-8">
      {/* HEADER & ACTION BAR */}
      <div className="max-w-8xl mx-auto mb-8 flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <h1 className="text-3xl font-black text-pink-900 flex items-center gap-3">
            <Box size={32} className="text-pink-600" />
            Product Dimensions
          </h1>
          <p className="text-pink-400 font-medium">Manage packaging logistics and shipping weight</p>
        </div>
        
        <div className="flex gap-3">
            <div className="relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-pink-300" size={18}/>
                <input 
                    type="text" 
                    placeholder="Search product..."
                    className="pl-10 pr-4 py-3 bg-white border border-pink-100 rounded-2xl outline-none focus:ring-2 ring-pink-200"
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>
            <button 
                onClick={handleOpenAdd}
                className="bg-pink-600 hover:bg-pink-700 text-white px-6 py-3 rounded-2xl font-bold flex items-center gap-2 shadow-lg shadow-pink-200 transition-all active:scale-95"
            >
                <Plus size={20} /> Add Dimensions
            </button>
        </div>
      </div>

      {/* TABLE VIEW */}
      <div className="max-w-8xl mx-auto bg-white rounded-[30px] shadow-xl border border-pink-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead className="bg-pink-50 text-pink-700 uppercase text-[11px] font-black tracking-widest">
              <tr>
                <th className="px-6 py-5">Box Image</th>
                <th className="px-6 py-5">Product Details</th>
                <th className="px-6 py-5">Weight</th>
                <th className="px-6 py-5">L x B x H (cm)</th>
                <th className="px-6 py-5">Status</th>
                <th className="px-6 py-5 text-center">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-pink-50">
              {filteredList.map((item) => {
                const product = productList.find(p => p.product_id === item.product_id);
                const unit = product?.units?.find(u => u.product_unit_id === item.product_unit_id);
                
                return (
                  <tr key={item.dimensions_id} className="hover:bg-pink-50/40 transition-colors">
                    <td className="px-6 py-4">
                      <div className="w-16 h-16 bg-gray-100 rounded-xl overflow-hidden border border-pink-100">
                        {item.box_image ? (
                          <img 
                            src={`${IMAGE_BASE_URL}/${item.box_image}`} 
                            alt="Box" 
                            className="w-full h-full object-cover"
                            onError={(e) => { e.target.src = "https://placehold.co/100x100?text=No+Img"; }}
                          />
                        ) : (
                          <div className="w-full h-full flex items-center justify-center text-pink-200"><ImageIcon /></div>
                        )}
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="font-bold text-gray-800">{product?.product_title || "Loading..."}</div>
                      <div className="text-xs text-pink-500 font-semibold uppercase">Pack of {unit?.pack_size || "N/A"}</div>
                    </td>
                    <td className="px-6 py-4 font-bold text-gray-700">{item.weight} g</td>
                    <td className="px-6 py-4 font-medium text-gray-600">
                      {item.length} x {item.breadth} x {item.height}
                    </td>
                    <td className="px-6 py-4">
                        <span className={`px-3 py-1 rounded-full text-[10px] font-bold uppercase ${item.is_active ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-400'}`}>
                            {item.is_active ? 'Active' : 'Inactive'}
                        </span>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <button 
                        onClick={() => handleOpenEdit(item)}
                        className="p-2 bg-pink-100 text-pink-600 rounded-xl hover:bg-pink-600 hover:text-white transition-all"
                      >
                        <Edit size={18} />
                      </button>
                    </td>
                  </tr>
                );
              })}
              {filteredList.length === 0 && !loading && (
                <tr><td colSpan="5" className="p-10 text-center text-pink-300 font-bold italic">No dimensions found</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* MODAL FORM */}
      {showModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 overflow-y-auto">
          <div className="bg-white w-full max-w-2xl rounded-[40px] shadow-2xl animate-in zoom-in duration-300 overflow-hidden my-auto">
            <div className="bg-gradient-to-r from-pink-600 to-red-500 p-6 flex justify-between items-center text-white">
              <h2 className="text-xl font-bold flex items-center gap-2">
                {isEditMode ? <Edit size={20}/> : <Plus size={20}/>}
                {isEditMode ? 'Edit Product Dimensions' : 'New Product Dimensions'}
              </h2>
              <button onClick={() => setShowModal(false)} className="hover:bg-white/20 p-2 rounded-full transition-all">
                <X size={24} />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="p-8 space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-1">
                        <label className="text-[10px] font-black text-pink-400 uppercase tracking-widest ml-1">Parent Product</label>
                        <select
                            required
                            className="w-full p-4 bg-gray-50 border-2 border-transparent focus:border-pink-500 focus:bg-white rounded-2xl outline-none transition-all font-semibold"
                            value={formData.product_id}
                            onChange={handleProductChange}
                            disabled={isEditMode}
                        >
                            <option value="">Choose Product...</option>
                            {productList.map(p => <option key={p.product_id} value={p.product_id}>{p.product_title}</option>)}
                        </select>
                    </div>

                    <div className="space-y-1">
                        <label className="text-[10px] font-black text-pink-400 uppercase tracking-widest ml-1">Unit/Variant</label>
                        <select
                            required
                            className="w-full p-4 bg-gray-50 border-2 border-transparent focus:border-pink-500 focus:bg-white rounded-2xl outline-none transition-all font-semibold"
                            name="product_unit_id"
                            value={formData.product_unit_id}
                            onChange={handleUnitChange}
                            disabled={isEditMode}
                        >
                            <option value="">Choose Unit...</option>
                            {unitList.map(u => <option key={u.product_unit_id} value={u.product_unit_id}>Pack of {u.pack_size}</option>)}
                        </select>
                    </div>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 bg-pink-50/30 p-6 rounded-[30px] border border-pink-100/50">
                    <DimensionInput label="Weight (g)" name="weight" icon={<Weight size={12}/>} val={formData.weight} onChange={handleInputChange} />
                    <DimensionInput label="Length (cm)" name="length" icon={<Ruler size={12}/>} val={formData.length} onChange={handleInputChange} />
                    <DimensionInput label="Breadth (cm)" name="breadth" icon={<Ruler size={12}/>} val={formData.breadth} onChange={handleInputChange} />
                    <DimensionInput label="Height (cm)" name="height" icon={<Ruler size={12}/>} val={formData.height} onChange={handleInputChange} />
                </div>

                <div className="space-y-1">
                    <label className="text-[10px] font-black text-pink-400 uppercase tracking-widest ml-1">Box Image</label>
                    <input type="file" onChange={(e) => setFormData({...formData, box_image: e.target.files[0]})} className="w-full p-3 border-2 border-dashed border-pink-100 rounded-2xl text-sm" />
                </div>

                <button 
                    disabled={loading}
                    className="w-full py-4 bg-pink-600 hover:bg-pink-700 text-white font-black rounded-2xl shadow-xl shadow-pink-100 transition-all transform active:scale-95 disabled:bg-gray-300"
                >
                    {loading ? "Processing..." : isEditMode ? "Update Details" : "Save Dimensions"}
                </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

// Reusable Input Component
const DimensionInput = ({ label, name, val, onChange, icon }) => (
  <div className="space-y-1">
    <label className="text-[9px] font-black text-gray-400 uppercase flex items-center gap-1 ml-1">
      {icon} {label}
    </label>
    <input
      type="number"
      required
      name={name}
      value={val}
      onChange={onChange}
      className="w-full p-3 bg-white border-2 border-pink-100/50 focus:border-pink-500 rounded-xl outline-none transition-all font-bold text-gray-700"
    />
  </div>
);

export default ProductDimentions;